import { render, staticRenderFns } from "./itemDetail.vue?vue&type=template&id=0b247101"
import script from "./itemDetail.vue?vue&type=script&lang=js"
export * from "./itemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports